
















import Vue from 'vue';

export default Vue.extend({
  props: {
    theme: { default: undefined, type: String },
  },
  computed: {
    hasFooterSlot() {
      return !!(this.$slots as any).footer;
    },
  },
  methods: {
  },
});
